module.exports = __webpack_public_path__ + "img/bg.ebae3122.jpg";